var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getBackgroundImage())?_c('img',{class:['thumbnail__background-image', {'vertical': _vm.isVertical }],attrs:{"srcset":`${_vm.getBackgroundImage().x1} 1x, ${_vm.getBackgroundImage().x2} 2x`,"src":_vm.getBackgroundImage().x1,"alt":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }